import _get from 'lodash/get';

export default (key, defaultValue = false) =>
    _get(window, `__PRELOADED_STATE__.${key}`, defaultValue);
